import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';

export const Print = {
    Container: styled.div`
        margin-bottom: 10px;
        width: 100px;
    `,
}

export const PalletSummary = {
    Container: styled.div`
        padding: 10px 10px 0;
        margin-top: 16px;
    `,
    Title: styled.div`
        font-size: 13px;
        font-weight: 700;
        color: #334155;
        margin-bottom: 8px;

        span { color: #94a3b8; font-weight: 600; }
    `,
    // 제목 + 축 토글(준비/확정)을 한 줄에
    TitleRow: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        margin-bottom: 8px;
        flex-wrap: wrap;

        > *:first-child { margin-bottom: 0; }
    `,
    // 요약 기준 축 전환 (준비 | 확정)
    AxisToggle: styled.div`
        display: inline-flex;
        flex-shrink: 0;
        background: #f1f5f9;
        border-radius: 10px;
        padding: 3px;
        gap: 2px;

        button {
            height: 28px;
            padding: 0 12px;
            border: none;
            background: transparent;
            border-radius: 8px;
            font-size: 12px;
            font-weight: 700;
            color: #64748b;
            cursor: pointer;
            transition: all .2s;
            white-space: nowrap;

            &:hover { color: #0f172a; }

            &.active {
                background: #fff;
                color: #0f172a;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
            }
        }
    `,
    Scroller: styled.div`
        display: flex;
        gap: 8px;
        overflow-x: auto;
        padding-bottom: 6px;
        -webkit-overflow-scrolling: touch;
    `,
    Card: styled.button`
        flex-shrink: 0;
        width: 88px;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        background: #fff;
        padding: 8px 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        cursor: pointer;
        transition: all .2s;

        .no {
            width: 28px; height: 28px;
            display: flex; align-items: center; justify-content: center;
            background: #f1f5f9;
            border-radius: 6px;
            font-size: 15px;
            font-weight: 800;
            color: #0f172a;
        }
        .stat { font-size: 13px; color: #2563eb; font-weight: 700; b { font-size: 16px; } }
        .sub { font-size: 11px; color: #64748b; }
        .confirm { font-size: 10px; color: #16a34a; font-weight: 700; }

        &:hover { border-color: #93c5fd; }
        &.selected {
            border-color: #2563eb;
            box-shadow: inset 0 0 0 1px #2563eb;
            background: #eff6ff;
        }

        /* 확정 축의 '미확정' 버킷 — 실제 작업 대상이라 강조 */
        &.unconfirmed {
            border-color: #fdba74;
            background: #fff7ed;

            .no {
                width: auto;
                padding: 0 8px;
                font-size: 12px;
                background: #ffedd5;
                color: #c2410c;
            }
            .stat { color: #ea580c; }

            &:hover { border-color: #fb923c; }
            &.selected {
                border-color: #ea580c;
                box-shadow: inset 0 0 0 1px #ea580c;
                background: #ffedd5;
            }
        }
    `,
    AddCard: styled.button`
        flex-shrink: 0;
        width: 88px;
        border: 1px dashed #93c5fd;
        border-radius: 10px;
        background: #f8fbff;
        color: #2563eb;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;

        .plus { font-size: 22px; line-height: 1; }
        &:hover { background: #eff6ff; }

        /* 확정 축에서는 확정 파레트를 생성 */
        &.confirm {
            border-color: #86efac;
            background: #f0fdf4;
            color: #16a34a;

            &:hover { background: #dcfce7; }
        }
    `,
}

export const MoveBar = {
    // 선택 여부에 따라 생겼다 없어지며 레이아웃이 밀리지 않도록 하단 고정 플로팅 바로 처리.
    // 항상 렌더링하고 .visible 토글로 슬라이드 인/아웃 → 테이블은 그대로.
    Container: styled.div`
        position: fixed;
        left: 50%;
        bottom: 20px;
        width: calc(100% - 40px);
        max-width: 520px;
        z-index: 1200;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        background: #0f172a;
        color: #fff;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);

        opacity: 0;
        pointer-events: none;
        transform: translateX(-50%) translateY(140%);
        transition: transform .25s ease, opacity .25s ease;

        &.visible {
            opacity: 1;
            pointer-events: auto;
            transform: translateX(-50%) translateY(0);
        }

        .count { font-size: 13px; font-weight: 700; }
        .actions { display: flex; gap: 8px; }
        .actions button {
            height: 34px;
            padding: 0 12px;
            border: none;
            border-radius: 8px;
            font-size: 12px;
            font-weight: 700;
            cursor: pointer;
        }
        .actions .clear { background: #334155; color: #cbd5e1; }
        .actions .move { background: #2563eb; color: #fff; }
    `,
}
export const PalletList = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 20px;
    `,
    Wrapper: styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
    `,
    LabelField: styled.div`
        font-size: 14px;
        font-weight: 600;
    `,
    PalletButton: styled(CustomBlockButton)`
        width: 24px;
        height: 24px;
        background: #efefef;
    `,
    // 준비/확정 필터를 동시에 적용하므로 어느 축의 필터인지 라벨로 항상 노출한다.
    PalletChip: styled.button`
        display: inline-flex;
        align-items: center;
        gap: 4px;
        height: 24px;
        padding: 0 8px;
        border: 1px solid transparent;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
        white-space: nowrap;

        .tag { font-size: 9px; font-weight: 800; opacity: .7; }
        .x { font-size: 11px; opacity: .55; }

        &.prep { background: #eef2ff; color: #4f46e5; border-color: #c7d2fe; }
        &.confirm { background: #dcfce7; color: #16a34a; border-color: #bbf7d0; }
        &.unconfirmed { background: #fff7ed; color: #ea580c; border-color: #fed7aa; }
    `,
    ClearAllButton: styled.button`
        height: 24px;
        padding: 0 8px;
        border: 1px solid #e2e8f0;
        border-radius: 999px;
        background: #fff;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;

        &:hover { color: #0f172a; border-color: #cbd5e1; }
    `,
    AddButtonField: styled.div`
        button{
            width: 24px;
            height: 24px;

            div{
                width: 100%;
            }
        }
    `,
}

export const SearchQuery = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 20px;
    `,
    Wrapper: styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        /* 세그먼트형 모드 토글 (입력/스캔) */
        .modeToggle {
            display: inline-flex;
            flex-shrink: 0;
            background: #f1f5f9;
            border-radius: 10px;
            padding: 3px;
            gap: 2px;

            button {
                height: 34px;
                padding: 0 14px;
                border: none;
                background: transparent;
                border-radius: 8px;
                font-size: 12px;
                font-weight: 700;
                color: #64748b;
                cursor: pointer;
                transition: all .2s;
                white-space: nowrap;

                &:hover { color: #0f172a; }

                &.active {
                    background: #fff;
                    color: #0f172a;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
                }
            }
        }

        /* 입력/스캔 결과 필드 (클리어 버튼 내장) */
        .inputField {
            position: relative;
            flex: 1;
            min-width: 220px;
            max-width: 360px;

            input,
            .scannedResult {
                width: 100%;
                height: 40px;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                padding: 0 34px 0 12px;
                font-size: 12px;
                font-weight: 600;
                outline: none;
                transition: all .2s;
            }

            input:focus {
                border-color: #2563eb;
                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
            }

            .scannedResult {
                display: flex;
                align-items: center;
                gap: 8px;
                background: #f8fafc;
                color: #0f172a;

                &.spaceField { color: #94a3b8; }

                /* 스캔 대기 표시용 점 */
                .scanDot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #22c55e;
                    flex-shrink: 0;
                    animation: scanPulse 1.4s ease-in-out infinite;
                }
            }

            .clearBtn {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                width: 22px;
                height: 22px;
                border: none;
                border-radius: 50%;
                background: #e2e8f0;
                color: #475569;
                font-size: 11px;
                line-height: 1;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all .2s;

                &:hover { background: #cbd5e1; color: #1e293b; }
            }
        }

        @keyframes scanPulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: .35; transform: scale(.8); }
        }
    `,
}

export const Table = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 10px;
    `,
    // 모바일에서 바디 스크롤 안에 테이블 스크롤이 겹치는(이중 스크롤) 문제를 없애기 위해
    // 고정 높이와 내부 overflow를 두지 않는다. 세로 스크롤은 페이지 하나만 사용하고,
    // 헤더는 아래 TableHeader에서 뷰포트 기준 sticky로 고정된다.
    Wrapper: styled.div`
        width: 100%;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    `,
    StyledTable: styled.table`
        width: 100%; // Total of all column widths
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
    `,
    ColumnGroup: styled.colgroup`
    `,
    TableHeader: styled.thead`
        position: sticky;
        top: 0;
        z-index: 10;

        /* thead 단위 sticky를 지원하지 않는 브라우저 대비로 셀에도 sticky/배경을 준다.
           (배경이 없으면 스크롤 시 행이 헤더 아래로 비쳐 보인다) */
        th {
            position: sticky;
            top: 0;
            background-color: #f0f4f8;
        }

        th:first-child { border-top-left-radius: 8px; }
        th:last-child { border-top-right-radius: 8px; }
    `,
    HeaderRow: styled.tr`
        &:first-child {
            th {
                padding: 10px 8px;
                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                border-bottom: 1px solid #e2e8f0;
            }
        }

        &:last-child {
            th {
                padding: 10px 8px;
                font-size: 11px;
                border-bottom: 2px solid #cbd5e0;
            }
        }
    `,
    HeaderCell: styled.th`
        text-align: left;
        color: #4a5568;
        font-weight: 600;
    `,
    TableBody: styled.tbody`
        /* Remove the alternating row color here */
    `,
    TableRow: styled.tr`
        transition: background-color 0.2s;
    
        &:hover {
            background-color: #edf2f7;
        }

        &.loadedY{
            background: var(--orangeColor1-light);
        }

        &.checked{
            background: #e0edff;
        }

        &.selectable{
            cursor: pointer;
        }
    `,
    TableCell: styled.td`
        padding: 10px 8px;
        border-bottom: 1px solid #e2e8f0;
        color: #2d3748;
        font-size: 11px;
        font-weight: 600;

        &.bold{
            font-weight: 700;
        }

        & .palletNumberButton{
            width: 30px;
            height: 30px;
        }

        & .palletBadges{
            display: flex;
            flex-direction: column;
            gap: 3px;
            align-items: flex-start;
        }
    `,
    BulkSelectButton: styled.button`
        margin-top: 4px;
        height: 24px;
        padding: 0 8px;
        border: 1px solid #c7d2fe;
        border-radius: 6px;
        background: #eef2ff;
        color: #4f46e5;
        font-size: 10px;
        font-weight: 700;
        white-space: nowrap;
        cursor: pointer;
        transition: all .15s;

        &:hover { background: #e0e7ff; }
    `,
    PrepBadge: styled.span`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        padding: 2px 7px;
        border-radius: 6px;
        font-size: 11px;
        font-weight: 700;
        white-space: nowrap;
        background: #eef2ff;
        color: #4f46e5;
    `,
    ConfirmedBadge: styled.span`
        display: inline-flex;
        align-items: center;
        padding: 2px 7px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 700;
        white-space: nowrap;
        background: #dcfce7;
        color: #16a34a;
    `,
    TypeBadge: styled.span`
        padding: 4px 8px;
        border-radius: 9999px;
        font-size: 11px;
        font-weight: 500;
        
        ${({ type }) => type === 'EXTRA' ? `
            background-color: var(--blueColor2-light);
            color: var(--blueColor2);
        ` : type === 'HETEROMORPHIC' ? `
            background-color: var(--orangeColor1-light);
            color: var(--orangeColor1);
        ` : `
            background-color: var(--greenColor1-light);
            color: var(--greenColor1);
        `}
    `,
    ConfirmButton: styled(CustomBlockButton)`
        height: 30px;
        width: 50px;
        font-size: 12px;
        border: none;
        

        ${({ $palletConfirmYn }) => $palletConfirmYn === 'y' ? `
            background: var(--redColor2-light);
            color: var(--redColor2);
        ` : `
            background: var(--blueColor2-light);
            color: var(--blueColor2);
        `}
    `,
}

export const CountField = {
    Container: styled.div`
        margin-top: 10px;
        padding: 10px;
        margin-bottom: 100px;
        display: flex;
        gap: 10px;
        font-size: 13px;
        font-weight: 600;
    `,
}
export const SelectPalletModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;

        .gridWrapper{
            display: grid;
            grid-template-columns: repeat(4,1fr);
            gap: 10px;

            .item{
                user-select: none;
                cursor: pointer;
                aspect-ratio: 1;
                border: 1px solid #ffffffff;
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: 700;
                transition: all .3s;
                background: #efefef;

                &:hover{
                    border-color: #000;
                }

                &.selected{
                    background: var(--blueColor2-light);
                }
            }
        }
    `,
}

export const ChangePalletNumberModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;

        .gridWrapper{
            display: grid;
            grid-template-columns: repeat(1,1fr);
            gap: 10px;

            .item{
                user-select: none;
                border: 1px solid #ffffffff;
                border-radius: 10px;
                display: flex;
                justify-content: space-between;
                gap: 10px;
                padding: 10px;
                align-items: center;
                font-size: 18px;
                font-weight: 700;
                transition: all .3s;
                background: #efefef;

                & button{
                    width: auto;
                    padding: 0 10px;
                    background: var(--blueColor1);
                    color: #fff;
                    border:none;
                }
            }
        }
    `,
}

export const PrintModeModal = {
    Header: styled.div`
        padding: 10px;
    `,
    Body: styled.div`
        padding: 10px;

        .printButton{
            width: 100px;
            margin-left: auto;
            border: none;
            background: var(--blueColor1);
            color: #fff;
        }
    `,
    TableContainer: styled.div`
        padding: 0;
        margin-top: 10px;

        @media print {
            padding: 0;
            @page { size: A4; margin: 10mm; }
            .wrapper{
                overflow: visible !important;
                height: auto !important;
                max-height: none !important;
            }

            .styledTable{
                table-layout: auto;
            }
        }

        .wrapper{
            width: 100%;
            overflow: auto;
            background: white;
    
        }

        .styledTable{
            width: 100%; // Total of all column widths
            table-layout: fixed;
            border-collapse: separate;
            border-spacing: 0;
        }

        thead{
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #f0f4f8;

            tr{
                & th{
                    text-align: left;
                    color: #4a5568;
                    font-weight: 600;
                }

                &:first-child {
                    th {
                        padding: 10px 8px;
                        font-size: 12px;
                        text-transform: uppercase;
                        letter-spacing: 0.05em;
                        border-bottom: 1px solid #e2e8f0;
                    }
                }
        
                &:last-child {
                    th {
                        padding: 3px;
                        font-size: 8px;
                        border-bottom: 1px solid #cbd5e0;
                    }
                }
            }
        }

        tbody{
            & tr{
                transition: background-color 0.2s;
            
                &:hover {
                    background-color: #edf2f7;
                }
        
                &.loadedY{
                    background: var(--orangeColor1-light);
                }

                & td{
                    padding: 3px;
                    border-bottom: 1px solid #e2e8f0;
                    color: #2d3748;
                    font-size: 8px;
                    font-weight: 600;
            
                    &.bold{
                        font-weight: 700;
                    }
            
                    & .palletNumberButton{
                        width: 30px;
                        height: 30px;
                    }
                }
            }
        }

        .palletNumber{
            width: 15px;
            height: 15px;
            border: 1px solid #000;
            border-radius: 2px;
            font-size: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,
}